;(() => {
	const initSlider = (section) => {
		let testimonialsSlider, navigation, pagination

		if (document.currentScript) {
			testimonialsSlider = document.currentScript.parentElement.querySelector(
				'.testimonials__slider'
			)
			if (testimonialsSlider) {
				navigation = document.currentScript.parentElement.querySelector(
					'.testimonials__navigation'
				)
				pagination = document.currentScript.parentElement.querySelector(
					'.testimonials__pagination'
				)
			}
		} else {
			testimonialsSlider = section.querySelector('.testimonials__slider')
			if (testimonialsSlider) {
				navigation = section.querySelector('.testimonials__navigation')
				pagination = section.querySelector('.testimonials__pagination')
			}
		}

		if (testimonialsSlider) {
			const columns = Number(testimonialsSlider.dataset.columns)
			let columns750
			if (columns > 1) columns750 = columns - 1
			else columns750 = columns

			let swiperParams = {
				slidesPerView: 1,
				slidesPerGroup: 1,
				spaceBetween: 24,
				mousewheel: {
					forceToAxis: true,
				},
				breakpoints: {
					750: {
						slidesPerView: columns750,
						slidesPerGroup: columns750,
					},
					1200: {
						slidesPerView: columns,
						slidesPerGroup: columns,
					},
				},
			}

			// Opt in per section so other testimonial sections retain their behavior.
			if (testimonialsSlider.dataset.autoplay === 'true') {
				// Swiper 10 needs at least twice the desktop column count for a seamless loop.
				const wrapper = testimonialsSlider.querySelector('.swiper-wrapper')
				const originalSlides = [...wrapper.children]
				if (originalSlides.length > 1 && originalSlides.length < columns * 2) {
					originalSlides.forEach((slide) => {
						const clone = slide.cloneNode(true)
						clone.querySelectorAll('[data-shopify-editor-block]').forEach((block) => {
							block.removeAttribute('data-shopify-editor-block')
						})
						wrapper.append(clone)
					})
				}
				swiperParams.loop = true
				swiperParams.speed = 9000
				swiperParams.breakpoints[750].slidesPerGroup = 1
				swiperParams.breakpoints[1200].slidesPerGroup = 1
				if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
					swiperParams.autoplay = {
						delay: 0,
						disableOnInteraction: false,
						pauseOnMouseEnter: false,
						reverseDirection: false,
					}
				}
			}

			if (testimonialsSlider.getAttribute('data-pagination') === 'true') {
				swiperParams.pagination = {
					el: pagination,
					type: 'bullets',
					clickable: true,
				}
			}

			if (testimonialsSlider.getAttribute('data-navigation') === 'true') {
				swiperParams.navigation = {
					nextEl: navigation.querySelector('.swiper-button-next'),
					prevEl: navigation.querySelector('.swiper-button-prev'),
				}
			}

			const testimonialsSwiper = new Swiper(testimonialsSlider, swiperParams)
			if (testimonialsSlider.dataset.autoplay === 'true') {
				const hoverArea = testimonialsSlider.closest('.testimonials__slider-wrapper')
				const pendingMoves = []
				let hovered = false
				let manualMove = false
				let resumeIndex = testimonialsSwiper.activeIndex
				let remainingDuration = 0

				const restartAutoplay = () => {
					if (swiperParams.autoplay && !hovered && !manualMove && !testimonialsSwiper.destroyed) {
						testimonialsSwiper.autoplay.start()
					}
				}
				const pauseImmediately = (event) => {
					if (event.pointerType !== 'mouse' || hovered) return
					hovered = true
					if (manualMove) return
					testimonialsSwiper.off('transitionEnd', restartAutoplay)
					const destination = testimonialsSwiper.translate
					const position = testimonialsSwiper.getTranslate()
					const stride = testimonialsSwiper.slidesSizesGrid[testimonialsSwiper.activeIndex] +
						Number(testimonialsSwiper.params.spaceBetween)
					resumeIndex = testimonialsSwiper.activeIndex
					remainingDuration = Math.abs(destination - position) / stride * testimonialsSwiper.params.speed
					testimonialsSwiper.autoplay.stop()
					testimonialsSwiper.setTransition(0)
					testimonialsSwiper.setTranslate(position)
					testimonialsSwiper.animating = false
				}
				const resumeMovement = (event) => {
					if (event.pointerType !== 'mouse' || !hovered) return
					hovered = false
					if (manualMove) return
					testimonialsSwiper.once('transitionEnd', restartAutoplay)
					const moving = testimonialsSwiper.slideTo(resumeIndex, Math.max(1, remainingDuration), true)
					if (!moving) {
						testimonialsSwiper.off('transitionEnd', restartAutoplay)
						restartAutoplay()
					}
				}
				const finishManualMove = () => {
					manualMove = false
					resumeIndex = testimonialsSwiper.activeIndex
					remainingDuration = 0
					if (pendingMoves.length) runNextMove()
					else restartAutoplay()
				}
				const runNextMove = () => {
					if (manualMove || !pendingMoves.length || testimonialsSwiper.destroyed) return
					const direction = pendingMoves.shift()
					manualMove = true
					testimonialsSwiper.off('transitionEnd', restartAutoplay)
					testimonialsSwiper.autoplay.stop()
					const position = testimonialsSwiper.getTranslate()
					testimonialsSwiper.setTransition(0)
					testimonialsSwiper.setTranslate(position)
					testimonialsSwiper.animating = false
					testimonialsSwiper.updateActiveIndex()
					testimonialsSwiper.updateSlidesClasses()
					const activeSlide = testimonialsSwiper.slides[testimonialsSwiper.activeIndex]
					// Preserve the visible position while loopFix moves offscreen cards.
					testimonialsSwiper.loopFix({
						direction: direction > 0 ? 'next' : 'prev',
						byMousewheel: true,
					})
					testimonialsSwiper.updateActiveIndex(testimonialsSwiper.slides.indexOf(activeSlide))
					testimonialsSwiper.updateSlidesClasses()
					// Commit the new DOM order and starting transform before animating.
					void testimonialsSwiper.wrapperEl.offsetWidth
					testimonialsSwiper.once('transitionEnd', finishManualMove)
					const speed = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 450
					const moving = testimonialsSwiper.slideTo(testimonialsSwiper.activeIndex + direction, speed, true)
					resumeIndex = testimonialsSwiper.activeIndex
					remainingDuration = 0
					if (!moving) {
						testimonialsSwiper.off('transitionEnd', finishManualMove)
						finishManualMove()
					}
				}
				const moveOneReview = (event, direction) => {
					event.preventDefault()
					event.stopImmediatePropagation()
					pendingMoves.push(direction)
					runNextMove()
				}
				const nextReview = (event) => moveOneReview(event, 1)
				const previousReview = (event) => moveOneReview(event, -1)
				const nextButton = navigation?.querySelector('.swiper-button-next')
				const previousButton = navigation?.querySelector('.swiper-button-prev')
				nextButton?.addEventListener('click', nextReview, true)
				previousButton?.addEventListener('click', previousReview, true)
				hoverArea.addEventListener('pointerenter', pauseImmediately)
				hoverArea.addEventListener('pointerleave', resumeMovement)
				if (hoverArea.matches(':hover')) pauseImmediately({ pointerType: 'mouse' })
				testimonialsSwiper.once('destroy', () => {
					pendingMoves.length = 0
					nextButton?.removeEventListener('click', nextReview, true)
					previousButton?.removeEventListener('click', previousReview, true)
					hoverArea.removeEventListener('pointerenter', pauseImmediately)
					hoverArea.removeEventListener('pointerleave', resumeMovement)
				})
			}
		}
	}

	const initMarqueeDesktop = (section) => {
		let testimonialsMarquee

		if (document.currentScript) {
			testimonialsMarquee =
				document.currentScript.parentElement.querySelectorAll(
					'.testimonials__marquee-swiper'
				)
		} else {
			testimonialsMarquee = section.querySelectorAll(
				'.testimonials__marquee-swiper'
			)
		}

		if (testimonialsMarquee.length != 0) {
			testimonialsMarquee.forEach((slider) => {
				const slides = slider.querySelectorAll('.swiper-slide')
				let sum = 0
				slides.forEach((slide) => {
					slide.style.height = slide.clientHeight + 'px'
					sum = sum + slide.clientHeight + 24
				})
				sum = sum - 24

				if (slides.length > 0) {
					let i = 0
					while (sum < slider.clientHeight * 2) {
						if (i > slides.length - 1) {
							i = 0
						}
						let clone = slider
							.querySelectorAll('.swiper-slide')
							[i].cloneNode(true)
						slider.querySelector('.swiper-wrapper').append(clone)
						i++
						sum = sum + clone.clientHeight + 24
					}
				}

				const testimonialsMarqueeSlider = new Swiper(slider, {
					slidesPerView: 'auto',
					spaceBetween: 24,
					direction: 'vertical',
					loop: true,
					shortSwipes: false,
					longSwipes: false,
					allowTouchMove: false,
					autoplay: {
						delay: 1,
					},
					freeMode: true,
					speed: 15000,
				})
			})
		}
	}

	const initMarqueeMobile = (section) => {
		let testimonialsMarquee

		if (document.currentScript) {
			testimonialsMarquee =
				document.currentScript.parentElement.querySelectorAll(
					'.testimonials__marquee-swiper_mobile'
				)
		} else {
			testimonialsMarquee = section.querySelectorAll(
				'.testimonials__marquee-swiper_mobile'
			)
		}

		if (testimonialsMarquee.length != 0) {
			testimonialsMarquee.forEach((slider) => {
				const testimonialsMarqueeSlider = new Swiper(slider, {
					slidesPerView: 3,
					spaceBetween: 24,
					direction: 'vertical',
					loop: true,
					shortSwipes: false,
					longSwipes: false,
					allowTouchMove: false,
					autoplay: {
						delay: 1,
					},
					freeMode: true,
					speed: 15000,
				})
			})
		}
	}

	const initSection = (section) => {
		let sectionTestimonials
		if (document.currentScript) {
			sectionTestimonials = document.currentScript.parentElement
		} else {
			sectionTestimonials = section
		}

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries

			if (entry.contentRect.width > 989) {
				const sliders = entry.target.querySelectorAll(
					'.testimonials__marquee-swiper'
				)
				if (sliders.length != 0) {
					sliders.forEach((slider) => {
						if (slider.swiper) slider.swiper.destroy()
					})
				}

				initMarqueeDesktop(sectionTestimonials)
			} else {
				const sliderMobile = entry.target.querySelector(
					'.testimonials__marquee-swiper_mobile'
				)
				if (sliderMobile) {
					if (sliderMobile.swiper) sliderMobile.swiper.destroy()
				}

				initMarqueeMobile(sectionTestimonials)
			}
		})

		sectionResizeObserver.observe(sectionTestimonials)
	}

	initSlider()
	initMarqueeDesktop()
	initMarqueeMobile()
	initSection()

	document.addEventListener('shopify:section:load', function (section) {
		initSlider(section.target)
		initMarqueeDesktop(section.target)
		initMarqueeMobile(section.target)
		initSection(section.target)
	})
})()

